import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Payment } from './payment.model';
import { PaymentService } from './payment.service';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class PaymentPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private paymentService: PaymentService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.paymentService.find(id).subscribe(payment => {
                if (payment.paymentDate) {
                    payment.paymentDate = {
                        year: payment.paymentDate.getFullYear(),
                        month: payment.paymentDate.getMonth() + 1,
                        day: payment.paymentDate.getDate()
                    };
                }
                this.paymentModalRef(component, payment);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            let payment: Payment = new Payment();
            let today: Date = new Date();
            payment.paymentDate = {
                    year: today.getFullYear(),
                    month: today.getMonth() + 1,
                    day: today.getDate()
                };
                setTimeout(() => {
                    // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                    return this.paymentModalRef(component, payment);
                });
        }
    }

    paymentModalRef(component: Component, payment: Payment): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.payment = payment;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment-popup.service.ts